import * as Util from "../Utils/Util";
import Events from "../Utils/Events";
import ProductState from "./ProductState";

export class ProductNameHolder {
  private readonly element: HTMLElement;

  public constructor(element: HTMLElement) {
    this.element = element;
    Events.on("product-state-change", (s: ProductState) => this.updateText(s));
  }

  private updateText(s: ProductState): void {
    this.element.innerHTML = s.product.label + " " + s.strength.label;
  }
}

export default function bindProductNameHolders(): void {
  const modals = Util.findByBindNameAll("product-name-holder");
  modals.forEach((s) => new ProductNameHolder(s as HTMLElement));
}
